<template>
  <div class="warpper">
    <HeadNei />
    <div class="content">
      <div class="flex poli_box flex_zBetween">
        <div class="poli_tel">
          <!-- <div class="poli-cell whole-bgt">
            <div class="poli_head whole-bgt">
              <div class="meas-name"><span>养殖场经营类型</span></div>
            </div>
            <FarmTypePieCharts
              :data="farmTypes"
              height="140px"
            ></FarmTypePieCharts>
          </div> -->
          <!-- <div class="poli-cell whole-bgt">
            <div class="poli_head whole-bgt">
              <div class="meas-name"><span>养殖场养殖类型</span></div>
            </div>
            <FarmTypePieCharts
              :data="breedTypes"
              height="140px"
            ></FarmTypePieCharts>
          </div> -->
          <div class="poli-cell whole-bgt">
            <div class="poli_head whole-bgt">
              <div class="meas-name">
                <span>存栏牛数量分布图（按行政村）</span>
              </div>
            </div>
            <scale-pie-charts
              width="100%"
              height="150px"
              :data="cattleScaleData"
            />
          </div>
          <div class="poli-cell whole-bgt">
            <div class="poli_head whole-bgt">
              <div class="meas-name">
                <span>存栏羊数量分布图（按行政村）</span>
              </div>
            </div>
            <scale-pie width="100%" height="150px" :data="sheepScaleData" />
          </div>
          <div class="poli-cell whole-bgt">
            <div class="poli_head whole-bgt">
              <!-- <div class="meas-name"><span>实时动态3</span></div> -->
              <div class="meas-name"><span>小程序二维码</span></div>
            </div>
            <div  class="seamless-warp">
              <img style="width: 139px; height: 139px;" src="../assets/images/realtime.jpg" alt="">
            </div>
            <!-- <vue-seamless-scroll
              :data="dynamicData"
              class="seamless-warp"
              :class-option="classOption"
              v-if="dynamicData.length > 0"
            >
              <div
                class="poli_cel"
                v-for="(item, index) in dynamicData"
                :key="index"
              >
                {{ item }}
              </div>
            </vue-seamless-scroll> -->
          </div>
        </div>
        <div class="poli_cent">
          <div class="poli-data whole-bgt">
            <div class="po_number">
              <div class="poli_col">
                <div style="margin-left: 10px" class="po_col_tt">
                  备案养殖场/户
                </div>
                <div class="po_col_num">
                   {{
                    statisticsData.farmCount !== 0
                      ? statisticsData.farmCount
                      : "--"
                  }}
                </div>
              </div>
              <div class="poli_col">
                <div class="po_col_tt">存栏牛数量</div>
                <div class="po_col_num">
                   {{
                    statisticsData.existCattleCount !== 0
                      ? statisticsData.existCattleCount
                      : "--"
                  }}
                </div>
              </div>
              <div class="poli_col">
                <div class="po_col_tt">存栏羊数量</div>
                <div class="po_col_num">
                   {{
                    statisticsData.existSheepCount !== 0
                      ? statisticsData.existSheepCount
                      : "--"
                  }}
                </div>
              </div>
              <div class="poli_col">
                <div class="po_col_tt">存栏蛋鸡数量</div>
                <div class="po_col_num">
                   {{
                    statisticsData.existPoultryCount !== 0
                      ? statisticsData.existPoultryCount
                      : "--"
                  }}
                </div>
              </div>
              <div class="poli_col">
                <div class="po_col_tt">存栏生猪数量</div>
                <div class="po_col_num">
                   {{
                    statisticsData.existOtherCount !== 0
                      ? statisticsData.existOtherCount
                      : "--"
                  }}
                </div>
              </div>
            </div>
          </div>
          <hsb-map-charts
            width="100%"
            height="680px"
            :data="mapChartData"
            :mapData="mapDatas"
            :allMap="allMap"
          />
        </div>
        <div class="poli_tel">
          <div class="poli-cell whole-bgt">
            <div class="poli_head whole-bgt">
              <div class="meas-name"><span>存栏量趋势</span></div>
              <div class="meas-input">
                <el-select
                    v-model="exitValue"
                    placeholder="全部"
                    @change="handleTrendChange"
                    popper-class="selectPopper"
                    :popper-append-to-body="false"
                >
                  <el-option
                      v-for="(item, index) in selectOption"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-date-picker
                    v-model="clYear"
                    type="year"
                    :clearable="false"
                    format="yyyy"
                    value-format="yyyy"
                    placeholder="选择年"/>
              </div>
            </div>
            <trend-line-charts
              width="100%"
              height="140px"
              :data="exitTrendData"
            />
          </div>
          <div class="poli-cell poli_cell_b whole-bgt">
            <div class="poli_head whole-bgt">
              <div class="meas-name"><span>入栏量统计</span></div>
              <div class="meas-input">
                <el-select
                    v-model="enterValue"
                    placeholder="全部"
                    @change="handleEnterChange"
                    popper-class="selectPopper"
                    :popper-append-to-body="false"
                >
                  <el-option
                      v-for="item in selectOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-date-picker
                    v-model="ruLYear"
                    type="year"
                    :clearable="false"
                    format="yyyy"
                    value-format="yyyy"
                    placeholder="选择年"/>

              </div>
            </div>
            <sta-bar-charts width="100%" height="150PX" :data="enterStaData" />
          </div>
          <div class="poli-cell poli_cell_c whole-bgt">
            <div class="poli_head whole-bgt">
              <div class="meas-name"><span>出栏量统计</span></div>
              <div class="meas-input">
                <el-select
                    v-model="exitStaVale"
                    placeholder="全部"
                    @change="handleExitChange"
                    popper-class="selectPopper"
                    :popper-append-to-body="false"
                >
                  <el-option
                      v-for="item in selectOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-date-picker
                    v-model="chuLYear"
                    type="year"
                    :clearable="false"
                    placeholder="选择年"
                    format="yyyy"
                    value-format="yyyy"/>
              </div>
            </div>
            <sta-bar-charts width="100%" height="140PX" :data="exitStaData" />
          </div>
        </div>
      </div>
      <div class="poli-bot">
        <div
          class="poli-bot-box"
          v-for="(item, index) in farmInfoArr"
          :key="index"
        >
          <div class="poli-bot-content">
            <div class="poli-content-text">
              <span>牛存栏量：</span>
              <span>{{ item.cattleExistCount + "头" }}</span>
            </div>
            <div class="poli-content-text">
              <span>其他存栏量：</span>
              <span>{{ item.otherExistCount | quantityFilter }}</span>
            </div>
            <div class="poli-content-text">
              <span>羊存栏量：</span>
              <span>{{ item.sheepExistCount | quantityFilter }}</span>
            </div>
            <div class="poli-content-text">
              <span>家禽存栏量：</span>
              <span>{{ item.poultryExistCount | quantityFilter }}</span>
            </div>
            <div class="poli-content-text">
              <span>销售总额：</span>
              <span>{{
                item.totalSales != 0 ? `${item.totalSales}元` : "--"
              }}</span>
            </div>
          </div>
          <div class="poli-bot-title">
            {{ item.regionName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hsbJson from "@/assets/map/hsbAdminMap.json";
import HeadNei from "@/components/HeadNei.vue";
import staBarCharts from "@/components/chart/staBarCharts";
import trendLineCharts from "@/components/chart/trendLineCharts";
import hsbMapCharts from "@/components/chart/hsbMapCharts";
// import vueSeamlessScroll from "vue-seamless-scroll";
import scalePieCharts from "@/components/chart/scalePieCharts";
import scalePie from "@/components/chart/scalePie";
import moment from "moment";

// import farmTypePieCharts from "@/components/chart/farmTypePieCharts";
// import FarmTypePieCharts from "../components/chart/farmTypePieCharts.vue";

export default {
  name: "Home",
  components: {
    scalePie,
    scalePieCharts,
    HeadNei,
    // vueSeamlessScroll,
    staBarCharts,
    trendLineCharts,
    hsbMapCharts,
    // FarmTypePieCharts,
  },
  computed: {
    classOption() {
      return {
        step: 0.5,
        limitMoveNum: this.dynamicData.length,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 1000,
      };
    },
  },
  data() {
    return {
      cattleAssortData: {},
      sheepAssortData: {},
      exitTrendData: {},
      enterStaData: {},
      exitStaData: {},
      mapChartData: [],
      dynamicData: [],
      farmInfoArr: [],
      farmTypes: [],
      breedTypes: [],
      mapDatas: [],
      sheepScaleData: {},
      cattleScaleData: {},
      allMap: hsbJson,
      statisticsData: {
        farmCount: 0,
        existCattleCount: 0,
        existSheepCount: 0,
        existPoultryCount: 0,
        existOtherCount: 0,
      },
      selectOption: [],
      exitValue: "all",
      enterValue: "all",
      exitStaVale: "all",
      // 存栏
      clYear: moment().format('YYYY'),
      // 人栏
      ruLYear: moment().format('YYYY'),
      // 出栏
      chuLYear: moment().format('YYYY'),
      timedRefresh: null,
    };
  },
  created() {},
  mounted() {
    console.log("screen mounted");
    this.initData();
    this.dataRefresh();
  },
  beforeDestroy() {
    this.clear();
  },
  watch: {
    clYear(){
      this.initChart(this.exitValue);
    },
    ruLYear(){
      this.initChart1(this.enterValue);
    },
    chuLYear(){
      this.initChart2(this.exitStaVale);
    }
  },
  methods: {
    // 规模养殖场分布
    async initChart4_cattle() {
      let { result } = await this.$api.center.dataDistribution({ type: "1" });
      this.cattleScaleData = result;
      // 演示数据 后期刚开上面接口
      // this.cattleScaleData = {
      //   totalCount: 67,
      //   oneToFifty: 1,
      //   fiftyToHundred: 2,
      //   hundredToFiveHundred: 16,
      //   fiveHundredToThousand: 22,
      //   moreThanThousand: 26,
      // };
    },

    async initChart4_sheep() {
      let { result } = await this.$api.center.dataDistribution({ type: "2" });
      this.sheepScaleData = result;
      // 演示数据 后期刚开上面接口
      // this.sheepScaleData = {
      //   totalCount: 67,
      //   oneToFifty: 7,
      //   fiftyToHundred: 17,
      //   hundredToFiveHundred: 25,
      //   fiveHundredToThousand: 13,
      //   moreThanThousand: 5,
      // };
    },

    dataRefresh() {
      if (this.timedRefresh != null) {
        return;
      }
      this.timedRefresh = setInterval(() => {
        this.initData();
      }, 1800000);
    },

    clear() {
      clearInterval(this.timedRefresh);
      this.timedRefresh = null;
    },

    initData() {
      this.initChart4_cattle();
      this.initChart4_sheep();
      this.initStatisticsData();
      this.initMapChart();
      this.initDynamicData();
      this.initChart("all");
      this.initChart1("all");
      this.initChart2("all");
      this.initFarmTypePipeChart();
      this.initSelectOptions();
    },

    // 下拉框数据请求
    async initSelectOptions() {
      const { result } = await this.$api.screen.screenSelectOptions();
      let selectOptions = result.map((item) => {
        return {
          value: item.regionCode,
          label: item.regionName,
        };
      });
      selectOptions.unshift({
        value: "all",
        label: "全部",
      });
      this.selectOption = selectOptions;
    },

    // 统计数据请求
    async initStatisticsData() {
      const { result } = await this.$api.screen.screenBasicCount();
      this.statisticsData = result;
    },

    // 实时动态数据
    async initDynamicData() {
      const { result } = await this.$api.screen.screenDynamic();
      this.dynamicData = result;
    },

    async initMapChart() {
      const { result } = await this.$api.screen.screenTownPoints();
      // 演示数据 后期刚开上面接口
      /*const result = [
        {
          regionName: "红寺堡镇",
          regionCode: "640303100",
          longitude: 106.0592651367,
          latitude: 37.4290694553,
          cattleExistCount: 20180,
          sheepExistCount: 184800,
          poultryExistCount: 141100,
          otherExistCount: 1887,
          totalSales: 0,
        },
        {
          regionName: "太阳山镇",
          regionCode: "640303101",
          longitude: 106.5014648437,
          latitude: 37.4912043732,
          cattleExistCount: 4329,
          sheepExistCount: 97917,
          poultryExistCount: 7568,
          otherExistCount: 1212,
          totalSales: 0,
        },
        {
          regionName: "大河乡",
          regionCode: "640303200",
          longitude: 105.910949707,
          latitude: 37.2434483787,
          cattleExistCount: 25710,
          sheepExistCount: 213600,
          poultryExistCount: 375800,
          otherExistCount: 325,
          totalSales: 0,
        },
        {
          regionName: "新庄集乡",
          regionCode: "640303201",
          longitude: 106.1636352539,
          latitude: 37.2325152113,
          cattleExistCount: 17978,
          sheepExistCount: 152900,
          poultryExistCount: 1576400,
          otherExistCount: 10356,
          totalSales: 0,
        },
        {
          regionName: "柳泉乡",
          regionCode: "640303202",
          longitude: 106.2295532227,
          latitude: 37.4792174449,
          cattleExistCount: 21928,
          sheepExistCount: 184500,
          poultryExistCount: 67600,
          otherExistCount: 973,
          totalSales: 0,
        },
      ];*/
      this.farmInfoArr = result;
      this.mapDatas = result.map((item) => {
        return {
          id: item.id,
          name: item.regionName,
          ...item,
        };
      });
      this.mapChartData = result.map((item) => {
        return {
          code: item.regionCode,
          name: item.regionName,
          value: [item.longitude, item.latitude],
        };
      });
    },

    // 存栏量趋势统计
    async initChart(code) {
      const params = code === "all" ? "" : code;
      let { result } = await this.$api.screen.screenExistTrend(params, this.clYear);
      console.log("存栏量趋势统计", result);
      this.exitTrendData = result;
      /*this.exitTrendData = {
        month: [11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        cattleCount: [
          111098, 120198, 122098, 123198, 122090, 121028, 112098, 112098,
          122098, 102098, 112098, 126098,
        ],
        sheepCount: [
          19834, 13734, 17734, 18632, 16034, 18334, 18634, 15731, 18234, 16733,
          19734, 18735,
        ],
        poultryCount: [
          44550, 43650, 42550, 43551, 47550, 43550, 43850, 43950, 41550, 43050,
          43950, 48550,
        ],
        otherCount: [
          2107, 3007, 2607, 3017, 2927, 2777, 2527, 3207, 2957, 3107, 3217,
          2827,
        ],
      };*/
    },

    // 入栏量统计
    async initChart1(code) {
      const params = code === "all" ? "" : code;
      let { result } = await this.$api.screen.screenEnterSta(params, this.ruLYear);
      console.log("进场量统计", result);
      this.enterStaData = result;
/*      this.enterStaData = {
        month: [1, 2, 3, 4],
        cattleCount: [1240, 1350, 1466, 0],
        sheepCount: [2140, 1352, 2105, 0],
        poultryCount: [1320, 1201, 1112, 0],
        otherCount: [231, 452, 362, 0],
      };*/
    },

    // 出栏量统计
    async initChart2(code) {
    // async initChart2() {
      const params = code === "all" ? "" : code;
      let { result } = await this.$api.screen.screenExitSta(params, this.chuLYear);
      // 演示数据 后期刚开上面接口
/*      let result = {
        month: [1, 2, 3, 4],
        cattleCount: [58200, 38200, 62210, 0],
        sheepCount: [78200, 98265, 65200, 0],
        poultryCount: [58200, 39200, 52200, 0],
        otherCount: [68200, 58200, 48200, 0],
      };*/
      this.exitStaData = result;
      console.log("出栏量统计", result);
    },

    //
    async initFarmTypePipeChart() {
      let { result } = await this.$api.screen.farmTypes();
      this.farmTypes = result;
      // console.log(result);

      let { result: result1 } = await this.$api.screen.breedTypes();
      this.breedTypes = result1;
      // console.log(result1);
    },

    handleTrendChange(val) {
      this.initChart(val);
    },

    handleEnterChange(val) {
      this.initChart1(val);
    },

    handleExitChange(val) {
      this.initChart2(val);
    },
  },
};
</script>
<style scoped>
.warpper {
  background: url(../assets/images/nei-bj.png), #091f36;
  background-size: 100% 100%;
  min-height: 100vh;
  position: relative;
}

.poli-data {
  background-image: url(../assets/images/screen/screen_title_bg.png);
  width: 825px;
  height: 117px;
  padding: 26px 6px 0;
}

.po_number {
  display: flex;
}

.poli_col {
  flex: 1;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.po_col_tt {
  font-size: 20px;
  font-weight: bold;
  color: #11ebf3;
  margin-right: 10px;
}

.po_col_num {
  font-size: 26px;
  font-weight: bold;
  color: #fffefe;
  /* max-width: 82px; */
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.poli_box {
  padding: 0 36px;
}

.poli_tel {
  width: 490px;
  position: relative;
  z-index: 99;
  margin-top: 8px;
}

.poli-cell {
  width: 100%;
  height: 235px;
  background-image: url(../assets/images/po2.png);
  padding: 10px;
  padding-bottom: 0px;
}

.poli-cell + .poli-cell {
  margin-top: 39px;
}

.poli_cell_b {
  background-image: url(../assets/images/po4.png);
}

.poli_cell_c {
  background-image: url(../assets/images/po5.png);
}

.poli_head {
  width: 442px;
  height: 28px;
  background-image: url(../assets/images/po3.png);
  margin: 0 auto 20px;
  position: relative;
  line-height: 20px;
  padding-left: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.seamless-warp {
  height: 140px;
  overflow: hidden;
}

.poli_cel {
  position: relative;
  font-size: 14px;
  color: #ffffff;
  height: 36px;
  line-height: 36px;
  padding: 0 10px 0 34px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.poli_cel:nth-child(odd) {
  background-color: rgba(93, 154, 224, 0.06);
}

.poli_cel:nth-child(even) {
  background-color: rgba(9, 9, 9, 0.06);
}

.poli_cel span {
  color: #00bbe9;
}

.poli_cel::before {
  content: "";
  width: 10px;
  height: 3px;
  background-color: #00bbe9;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 10px;
}

.meas-name span {
  font-size: 20px;
  background-image: -webkit-linear-gradient(top, #4bbaef, #ffffff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  transform: skewX(-10deg);
  display: block;
  width: max-content;
}

.meas-input{
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  top: -5px;
}

.meas-input .el-input{
  width: max-content;
}

.meas-input .el-input /deep/ .el-input__inner{
  text-align: center;
}

.poli_head /deep/ .el-select {
  //position: absolute;
  //top: -8px;
  //right: 8px;
}

.poli_head /deep/ .el-input__inner {
  background-color: rgba(31, 158, 204, 0.2);
  border-color: #00bbe9 !important;
  border-radius: 0;
  width: 102px;
  height: 30px;
  line-height: 30px;
  color: #e2ebf1;
  font-size: 14px;
  padding: 0 10px;
}

.poli_head /deep/ .el-input__icon {
  line-height: 30px;
}

.poli_head /deep/.selectPopper {
  /* background-color: rgba(31, 158, 204, 0.2); */
  background-color: rgba(9, 48, 106);
  border-color: #00bbe9 !important;
}

.poli_head /deep/ .selected {
  color: #ffffff !important;
}

.poli_head /deep/ .el-select-dropdown__item {
  color: #00bbe9;
}

.poli_head /deep/ .hover {
  color: #ffffff !important;
  background-color: rgba(31, 158, 204, 0.5);
}

.poli_cent {
  margin: 0 22px;
  width: 825px;
  height: 737px;
}

.poli-bot {
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  padding: 10px 34px 10px 29px;
}

.poli-bot-box {
  min-width: 366px;
  height: 178px;
  margin-left: 6px;
  background-image: url(../assets/images/screen/screen_bot_bg.png);
  background-size: 100% 100%;
}

.poli-bot-content {
  height: 154px;
  padding: 25px 36px 0 24px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.poli-content-text span:first-child {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}

.poli-content-text span:last-child {
  font-size: 14px;
  font-weight: 800;
  color: #00d8ff;
}

.poli-bot-title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
